export const IconLeft = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4375 5.27344L3.5625 11.8359C3.36719 12.0312 3.25 12.2656 3.25 12.5391C3.25 12.7734 3.36719 13.0078 3.5625 13.2031L10.4375 19.7656C10.7891 20.1172 11.4141 20.1172 11.7656 19.7266C12.1172 19.375 12.1172 18.75 11.7266 18.3984L6.53125 13.4766H19.8125C20.3594 13.4766 20.75 13.0469 20.75 12.5391C20.75 11.9922 20.3594 11.6016 19.8125 11.6016H6.53125L11.7266 6.64062C12.1172 6.28906 12.1172 5.66406 11.7656 5.3125C11.4141 4.92188 10.8281 4.92188 10.4375 5.27344Z"
        fill="#353535"
      />
    </svg>
  );
};
